import { AnalyticsEvents } from '../enums/analytics';
import { getUserShAccountId, getUserTrackingId } from './user-details';

export const getDemoAccountEntryPoint = () =>
  sessionStorage.getItem('demoAccountEntryPoint');

export const setDemoAccountEntryPoint = (entryPoint: string) => {
  sessionStorage.setItem('demoAccountEntryPoint', entryPoint);
};

export const removeDemoAccountEntryPoint = () => {
  sessionStorage.removeItem('demoAccountEntryPoint');
};

export const getDemoAccountModuleViewed = () =>
  sessionStorage.getItem('demoAccountModuleViewed');

export const setDemoAccountModuleViewed = (moduleViewed: string) => {
  let demoAccountModuleViewed: Record<string, boolean> = {};

  try {
    const stored = getDemoAccountModuleViewed();
    if (stored) {
      demoAccountModuleViewed = JSON.parse(stored);
    }
  } catch (e) {
    demoAccountModuleViewed = {};
  }

  if (!demoAccountModuleViewed[moduleViewed]) {
    setTimeout(() => {
      window.analytics?.track?.({
        userId: getUserTrackingId(),
        event: AnalyticsEvents.DemoModuleViewed,
        properties: {
          shAccountId: getUserShAccountId(),
          module_name: moduleViewed,
        },
      });
    }, 0);
    demoAccountModuleViewed[moduleViewed] = true;
  }

  sessionStorage.setItem(
    'demoAccountModuleViewed',
    JSON.stringify(demoAccountModuleViewed),
  );
};

export const removeDemoAccountModuleViewed = () => {
  sessionStorage.removeItem('demoAccountModuleViewed');
};

export const getIsDemoFeedbackSubmitted = () =>
  sessionStorage.getItem('isDemoFeedbackSubmitted');

export const setIsDemoFeedbackSubmitted = () => {
  sessionStorage.setItem('isDemoFeedbackSubmitted', 'true');
};

export const removeIsDemoFeedbackSubmitted = () => {
  sessionStorage.removeItem('isDemoFeedbackSubmitted');
};
